import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentAttachment } from '../models/document-attachment';
import { DocumentPersistenceService } from '../services/document-persistence.service';
import { LinkedDocument } from '../../shared/models/linked-documents';

@Component({
  selector: 'app-document-slider',
  templateUrl: './document-slider.component.html',
  styleUrls: ['./document-slider.component.scss'],
})
export class DocumentSliderComponent implements OnInit, OnChanges, OnDestroy {
  // Parameters for communication between the components
  @Output() isDocumentSliderActive = new EventEmitter<boolean>();
  @Input() isDocumentSliderOpen: boolean = false;
  @Input() documentAttachments: DocumentAttachment[] = [];
  @Input() disableSourceFileSectionOnDcumentCheckout!:boolean;
  @Input() isFileCheckedOut!:boolean;
  @Input() isGlobalDocument?: boolean;
  @Input() relatedDocuments!:LinkedDocument[];
  @Input() isInternalClientContactLimitedAccess: boolean = false;
  otherTabsEnabled: boolean = false;
  errorIconClassForTab = '';
  errorIconClassForFilesTab = '';
  isDocumentEditSlider = false;
  currentTab = 0;
  activeTab = 0;
  isDocumentSaveInProgress = false;
  showFilesTab = false;
  constructor(private documentPersistenceService: DocumentPersistenceService) { }

  ngOnInit(): void {
    // To Do : Need to remove this showFilesTab usage 
    // once control accepts savedFiles array dynamically
    this.showFilesTab = true;
    this.documentPersistenceService.checkSliderFromDocumentDetails();
    this.isDocumentEditSlider = this.documentPersistenceService.isDocumentEditSlider;
    this.documentPersistenceService.updateSavedDocuments(this.documentAttachments);
    this.documentPersistenceService.documentSaveInProgress$.
      subscribe((documentSaveStatus) => {
        this.isDocumentSaveInProgress = documentSaveStatus;
      });
    this.documentPersistenceService.closeAndResetDocumentSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetDocumentSlider(); }
    });
    
    this.documentPersistenceService.navigateToErrorTabOnSave$.subscribe((tabIndex) => {
      if ( this.isDocumentEditSlider && tabIndex > 0) {
        this.openCurrentTab(tabIndex);
      }
    });
    this.documentPersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      if (property === DocumentLibraryConstants.Document_Slider_Open) {
        this.isDocumentSliderOpen =
          changes[DocumentLibraryConstants.Document_Slider_Open].currentValue;
        this.showFilesTab = this.isDocumentSliderOpen;
      }
      if (property === DocumentLibraryConstants.Internal_Client_Contact_Limited_Access) {
        if (changes[DocumentLibraryConstants.Internal_Client_Contact_Limited_Access].currentValue === true) {
          this.otherTabsEnabled = true;
        }
      }
    }
  }

  closeSlider() {
    this.documentPersistenceService.openConfirmationDialog();
  }
  onEnableOtherTabs(enable: boolean) {
    this.otherTabsEnabled = enable;
  }

  closeAndResetDocumentSlider() {
    this.isDocumentSliderOpen = false;
    this.showFilesTab = false;
    this.activeTab = 0;
    this.currentTab = 0;
    this.documentPersistenceService.onTabChange(-1);
    this.documentPersistenceService.onCustomTabChange(-1);
    this.isDocumentSliderActive.emit(this.isDocumentSliderOpen);
  }
  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }
  onTabChange = (event: any) => {
    this.otherTabsEnabled = false;
    this.documentPersistenceService.onTabChange(this.currentTab);
    this.documentPersistenceService.onCustomTabChange(event.index);
    this.currentTab = event.index;
  }
  showErrorIconForTab = () => {
    this.errorIconClassForTab = '';
    this.errorIconClassForFilesTab = '';
    this.documentPersistenceService.errorTabIndices.forEach((tabIndex) => {
      switch (tabIndex) {
        case DocumentLibraryConstants.Document_Menu_General_Tab_Index:
          this.errorIconClassForTab = 'pi pi-exclamation-triangle';
          break;
        case DocumentLibraryConstants.Document_Menu_File_Tab_Index:
          this.errorIconClassForFilesTab = 'pi pi-exclamation-triangle';
          break;
      }
    })

  }
  ngOnDestroy = () => {
    this.documentPersistenceService.documentDetails$.unsubscribe();
    this.documentPersistenceService.documentSaveInProgress$.unsubscribe();
    this.documentPersistenceService.currentTabInSliderMenu$.unsubscribe();
    this.documentPersistenceService.closeAndResetDocumentSlider$.unsubscribe();
    this.documentPersistenceService.currentTabInSliderMenuByCustomChange$.unsubscribe();
    this.documentPersistenceService.populateErrorsForTab$.unsubscribe();
    this.documentPersistenceService.navigateToErrorTabOnSave$.unsubscribe();
  }
}
